// var d3 = {
//     ...require("d3-axis/dist/d3-axis.min"),
//     ...require("d3-scale/dist/d3-scale.min"),
//     ...require("d3-selection/dist/d3-selection.min"),
//     ...require("d3-geo/dist/d3-geo.min"),
//     ...require("d3-array/dist/d3-array.min"),
//     ...require("d3-scale-chromatic/dist/d3-scale-chromatic.min")
//   };

var d3 = require("d3/dist/d3.min");
var us = require("./us-states.json");

var { COLORS, classify, makeTranslate, formatStyle, wrapText, formatDate } = require("./lib/helpers");
var { monthYear, dateFull } = require("./lib/helpers/formatDate");
var { isMobile } = require("./lib/breakpoints");


module.exports = function(config) {



  

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html("");


  // Color scale for main characters
  var colorScale = d3.scaleOrdinal()
  .domain(Object.keys(PEOPLE))
  .range([ "#A23520","#E38D2C",  "#17807E", "#51AADE" ])

  // Set up tool tip

  var maxTooltipWidth = 275;
  var tooltip = containerElement.append("div")
    .attr("class", "tooltip")
    .style("display", "none");




  function renderLegend(){
    //Render the legend
    var legend = containerElement
      .append("ul")
      .attr("class", "key")
      .selectAll("g")
      .data(colorScale.domain())
      .enter()
        .append("li")
        .attr("class", (d, i) => `key-item key-${i} ${classify(d)}`);

    legend.append("b")
      .style("background-color", d => colorScale(d));

    legend.append("label").text(d => PEOPLE[d]);
  };

// Render map things outside of function --------------------------

// Setup // ----------------------------
renderLegend();


var aspectWidth = isMobile.matches ? 4 : 16;
var aspectHeight = isMobile.matches ? 2.6 : 9;


var margins = {
  top: 5,
  right: 5,
  bottom: 30,
  left: 5,
};


// var states_data = topojson.feature(us, us.objects.state);

// Calculate actual chart dimensions ---------------------------------------
var chartWidth = config.width - margins.left - margins.right;
var chartHeight =
  Math.ceil((config.width * aspectHeight) / aspectWidth) -
  margins.top -
  margins.bottom;



var projection = d3.geoAlbersUsa()
.translate([chartWidth / 2, chartHeight / 2])
  .fitSize([chartWidth, chartHeight], us);

var path = d3.geoPath().projection(projection);



//create svg for map -------------------------------------------------------
var mapWrapper = containerElement
.append("div")
.attr("class", "map-wrapper");

var mapElement = mapWrapper
.append("svg")
.attr("width", chartWidth + margins.left + margins.right)
.attr("height", chartHeight + margins.top + margins.bottom)
.attr("role", "img") // screenreader support
.append("g")
.attr("transform", `translate(${margins.left},${margins.top})`);


// Add states -------------------------------------------------------------------

var states = mapElement
  .selectAll('.states')
  .data(us.features)
  .enter()
  .append('path')
  .attr('class', 'states on')
  .attr('fill', "#ddd")
  .attr("stroke", "#fff")
  .attr("stroke-linejoin", "round")
  .attr("stroke-linecap", 'round')
  .attr('d', path);



  function renderMap(){



    drawDots(config.data, mapElement, projection);






  };


  // Draw Dots Functions ----------------------------------------------
  function drawDots(data,mapElement, projection){

    // Add dots --------------------------------------------------------------------------

    mapElement.append("g")
    .attr("class", "people-dots")



    var people = mapElement.select(".people-dots")
        .selectAll("circle")
        .data(data)
        .join(

          function(enter) {
              return enter
              .append('circle')
              .attr('transform',({ lon_jitter, lat_jitter }) => `translate(${projection([lon_jitter, lat_jitter  ]).join(",")})`)
              .style("fill", function(d){ return colorScale(d.name) })
              .attr("r", 1)
              .style("opacity", 0.75)
              .call(enter => enter.transition().duration(200).attr("r", 3.5));


          },
          function(update) {
              return update
                  .call(update => update.transition().duration(200).style('opacity', 0.2));
          },
          function(exit) {
              return exit
              .remove();
          }

      )
        .attr("name", d=> d.name)
        .attr("city", d=> d.city)
        .attr("state", d=> d.state)
        .attr("date", d=> d.date);



    // Add tooltip -----------------------------------------------

    people.on("mouseover", function(d){
      if(isMobile.matches) return;
      // this.select(this).style("cursor", "pointer");
      var el = d3.select(this);
      var name = el.attr("name");
      var targets = d3.selectAll(`[name='${name}']`);
      el.classed("highlight", true);
      var city =  el.attr("city");
      var state =  el.attr("state");
      var date =  el.attr("date");
      targets.raise();
      addTooltip(d, name, city, state, date);
    })
    .on("mousemove", function(){
        if(isMobile.matches) return;
        moveTooltip(d3.mouse(containerElement.node()));
    })
    .on("mouseout", function(){

      Â  Â  Â  Â  if(isMobile.matches) return;

      Â  Â  Â  Â  var el = d3.select(this);

      Â  Â  Â  Â  var name = el.attr("name");

      Â  Â  Â  Â  var targets = d3.selectAll(`[name='${name}']`);

      Â  Â  Â  Â  el.classed("highlight", false);

      Â  Â  Â  Â  //remove tooltip

      Â  Â  Â  Â  tooltip.style("display", "none");

      Â  Â  Â  });




    // Change opacity of dots on person selection -----------------------------
    d3.selectAll("input[name=person-choice]").on("change", function(d){
      // value of selected radio
      if (this.checked == true){
        var value = this.value;

        // var targets = d3.selectAll(`[name='${person_choice}']`);
        // targets.raise();
        // targets.style("fill", "pink");

        // uncheck all the others
        var allChecks = d3.selectAll("input[name=person-choice]:checked");
        
        allChecks.each(function() {
          if (this.value != value) {
            this.checked = false;
          }
        });

        // set dot opacity
        var all_dots = d3.selectAll("circle");
        all_dots.style("opacity", function(d) {
          if (d.name == value) {
            return 1;
          } else {
            return 0.2;
          }
        });
      } else{
        var all_dots = d3.selectAll("circle");
        all_dots.style("opacity", 0.75);
      }
    });
  }





  // Tool tip functions ----------------------------------------------

  function addTooltip(d, name, city, state, date){
    tooltip.style("display", "block");
    tooltip.html("");

    // console.log(d.table_props);

    var content = tooltip.append("div").attr("class", "content");



      //check for abortion and unintended pregnancy data, add table
      // var abortionRate = d.table_props["abortion_estimate"] ? `<span class='val'>${d.table_props["abortion_estimate"]}</span> per 1,000 women of reproductive age<span class="footnote">â¡</span> annually` : "NA";
      // var unintendedPregnancyRate = d.table_props["unintended_pregnancy_estimate"] ? `<span class='val'>${d.table_props["unintended_pregnancy_estimate"]}</span> per 1,000 women of reproductive age<span class="footnote">â¡</span> annually` : "NA";

      var innerContent = `<h4>${name}</h4>
                          <table>
                            <tbody>
                              <tr>
                                <td>Date:</td>
                                <td>${formatDate.dateFull(new Date(date+"T00:00"))}</td>
                              </tr>
                              <tr>
                                <td>Location:</td>
                                <td>${city}, ${state}</td>
                              </tr>
                              </tbody>
                          </table>`;

      content.html(innerContent);

  }


  function moveTooltip(mousePosition){
    var top = mousePosition[1]+10;
    var left = mousePosition[0]+10;

    //get bounding box of container
    var bbox = containerElement.node().getBoundingClientRect();

    var tooFarRight = (left + maxTooltipWidth) > bbox.width;
    //if the right side is too far right, shift tooltip left
    if(tooFarRight){
      var right = bbox.width - mousePosition[0]+10;
      tooltip.style("left", "auto");
      tooltip.style("right", right+"px")

    } else {
      tooltip.style("right", "auto");
      tooltip.style("left", left+"px")
    }

    tooltip.style("top", top+"px");
  }





  // Figuring out timer

  var formatDateSlider = d3.timeFormat("%b %Y");
  var parseDate = d3.timeParse("%Y-%m-%d");
  // T%H:%M:%SZ

  function update_timeline(order_number) {
    // update position and text of label according to slider scale

    // Show blank for feb because there is no data
    if(order_number == 1){

      let valueElement = document.querySelector('.range .range__value .dateValue');
      valueElement.innerHTML = "Feb. 2021";


    } else {

      // filter data set and redraw plot

    var newData = config.data.filter(function(d) {
      // d.date_parsed = parseDate(d.date)
      // d.date_slider = formatDateSlider(d.date_parsed)
      return d.order <= order_number;
    });

    var sliderOutput = config.data.filter(function(d){

      d.date_parsed = parseDate(d.date)
      // console.log(d.date_parsed)
      // d.date_slider = formatDateSlider(d.date_parsed)
      d.date_slider = monthYear(d.date_parsed);

      var c = d.order == order_number;

     

      return c ;
    });

    var month_year = sliderOutput[0].date_slider;

    let valueElement = document.querySelector('.range .range__value .dateValue');
    valueElement.innerHTML = month_year;


    drawDots(newData, mapElement, projection);



    }



    

  }





  const btnUploadFile = document.querySelector(".timeline");



  d3.select(".timeline").on("click",function(){

    var allChecks = d3.selectAll("input[name=person-choice]:checked");
    
    allChecks.each(function() {
      if (this.value != false) {
        this.checked = false;
      }
    });

    
    

    

    let count = 0;
    let func = function () {

      btnUploadFile.disabled = true;

      // timer.restart(func, 400);
      if (count == 18 ){
        
        // console.log(timerStarted)
        let valueElement = document.querySelector('.range .range__value .dateValue');
        valueElement.innerHTML = "Jan. 6, 2021 - June 30, 2022";

        timer.stop();

        d3.selectAll("circle")
        .style("opacity", 0.75);
        btnUploadFile.querySelector(".button__progress").style.width = `${0}%`;

        // timerStarted = false;

        btnUploadFile.disabled = false;

        //



      } else {
       
        
        var datetonumber = d3.scaleLinear()
        .domain([0,17])
        .range([0,100]);

        btnUploadFile.querySelector(".button__progress").style.width = `${datetonumber(count)}%`;

        update_timeline (count);

        ++count;

      }

    };



      var timer = d3.interval(func, 400);


  });




  // Render Elements onto graph ---------------------------------------

  renderMap();





  // Jquery show more







};
